import React from 'react';
import {useSelector} from 'react-redux';
import ScrollToTopComponent from './ScrollToTop';

const ScrollToTop = () => {
    const translation = useSelector((state) => state.modules.scrollToTopText);

    return <ScrollToTopComponent translation={translation} />;
};

ScrollToTop.displayName = 'ScrollToTop';

export default ScrollToTop;
